module.exports = __webpack_public_path__ + "static/media/carouselD.7709996c.jpg";